import { KeyPair } from '@/shared/lib/secure-json/core/crypto-core/types';
import { SecureJsonBase } from '@/shared/lib/secure-json/core/secure-json-base';
import { CollectionName } from '@/shared/lib/sj-orm/constants';

import { Loader } from '../loaders/types';

// TODO WA-1486 move to hook
export class Synchronizer {
  constructor(
    private readonly keyPair: KeyPair,
    private readonly loader: Loader,
    private readonly onCollectionLoaded: (name: CollectionName, collection: SecureJsonBase) => void,
  ) {}

  // public async push(
  //   collectionName: CollectionName,
  //   collection: SerializedCollection,
  // ): Promise<boolean> {
  //   await this.loader.push(collectionName, collection);
  //   return true;
  // }

  public async pull(collectionName: CollectionName): Promise<boolean> {
    const data = await this.loader.pull(collectionName);

    const sjCollection = new SecureJsonBase(this.keyPair.privateKey);
    if (data) {
      await sjCollection.fromStringAsync(data);
    }

    this.onCollectionLoaded(collectionName, sjCollection);

    return true;
  }
}
